import './NewsPage.css';

import React, { useContext } from 'react';

import { RouteComponentProps, useParams } from 'react-router';
import { AppPage } from '../AppContent';
import { FormattedMessage } from 'react-intl';
import { NotifItem } from '../components/notifications/NotifItem';
import { AppContext } from '../state/AppContextProvider';

interface NotifsPageProps extends RouteComponentProps { }

const NotifsPage: React.FC<NotifsPageProps> = (props: NotifsPageProps) => {
  const { state } = useContext(AppContext);

  const { notifId }: any = useParams();

  return (
    <AppPage>
      <div className="md:px-14">
        <h1 className="text-center text-2xl font-medium mb-4 mt-4">
          <FormattedMessage id="Notifications" />
        </h1>
        <ul className="flex flex-col mt-8 gap-1 md:overflow-hidden md:rounded-2xl md:p-4 md:bg-white">
          {state.allNotifs.map((notif, index) => (
            <NotifItem
              id={notif.id}
              title={notif.content.rendered}
              state={notif.acf.state}
              date={notif.date}
              link={notif.acf.link}
              sender={notif.acf.sender}
              key={index}
              selected={notif.parent === +notifId}
            />
          ))}
        </ul>
      </div>
    </AppPage>
  );
};

export default NotifsPage;
